import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Bundle } from '../components/Bundle';
import { Pricing } from '../components/Pricing';
import { Guarantee } from '../components/Guarantee';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-purple-500/30" data-id="element-173">
      <Hero data-id="element-174" />
      <Problem data-id="element-175" />
      <Solution data-id="element-176" />
      <Bundle data-id="element-177" />
      <Pricing data-id="element-178" />
      <Guarantee data-id="element-179" />
      <Footer data-id="element-180" />
    </div>;
}